import { render } from "./RegisterActivate.vue?vue&type=template&id=41e31087&ts=true"
import script from "./RegisterActivate.vue?vue&type=script&lang=ts"
export * from "./RegisterActivate.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__